import { isDemo } from '$lib/PersistedState.svelte.js';

export async function load({ parent, url }) {
  await parent();

  const demoKey = url.searchParams.get('demo');

  if (demoKey === 'sekrt') {
    isDemo.current = true;
  }

  return {};
}
